import React, { useEffect, useState, useContext } from "react";
import "./Footer.css";
import { FooterData } from "../../utils/apis/footer/Footer";
import { Context } from "../../utils/context";
import { IDS } from "../../utils/common";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInstagram,
  faWhatsapp,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope, faPhoneVolume } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { getSocialMedia } from "../../utils/apis/footer/Footer";

const Footer = () => {
  const navigate = useNavigate();
  const { IMG_URL } = useContext(Context);
  const [appsetup, setAppSetup] = useState({});

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const [socialmedia, setSocialMedia] = useState([]);

  const getMedia = async () => {
    const res = await getSocialMedia();
    if (res?.success) {
      setSocialMedia(res.data);
    }
  };

  const getAppSetup = async () => {
    const res = await FooterData();
    if (res?.success) {
      setAppSetup(res?.data?.[0] || {});
    }
  };

  useEffect(() => {
    getAppSetup();
    getMedia();
  }, []);

  return (
    <footer className="footer-new">
      <div className="footer-card ">
        <div className="logo-box"></div>
        <div className="black"></div>
        <div className="img-wrapper">
          {" "}
          <img
            // src={IDS?.IMG_URL + appsetup?.logo}
            src="/assets/images/newhome/homelogo.png"
            alt="logo"
            className="logo-img"
          />
        </div>
        <p className="footer-desc">
          Delivering high-impact stage effects that transform events into
          unforgettable experiences.
        </p>
        <div className="contact-box ">
          <p className="data">
            <FontAwesomeIcon icon={faPhoneVolume} /> {appsetup?.contact_no}
          </p>
          <p className="data">
            <FontAwesomeIcon icon={faPhoneVolume} /> {appsetup?.alt_contact_no}
          </p>
          <p className="data">
            <FontAwesomeIcon icon={faEnvelope} /> {appsetup?.email}
          </p>
        </div>
        <div className="bottom-wrapper">
          <div className="footer-btns">
            <button onClick={() => navigate("/terms-of-services")}>
              Terms & Conditions
            </button>
            <button onClick={() => navigate("/privacy-policy")}>
              Privacy Policy
            </button>
          </div>

          <div className="social-box">
            <p>Social Media</p>
            <div className="icons">
              {socialmedia?.map((item, index) => (
                <a
                  // href="https://instagram.com/your_username"
                  href={item?.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {/* <FontAwesomeIcon icon={faInstagram} /> */}
                  <img
                    src={IDS?.IMG_URL + item?.logo}
                    alt={item?.name}
                    className="social-icon-img"
                  />
                </a>
              ))}
              {/* <a
                  href="https://wa.me/919999999999"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon icon={faWhatsapp} />
                </a>

                <a
                  href="https://youtube.com/@your_channel"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon icon={faYoutube} />
                </a> */}
            </div>
          </div>
        </div>{" "}
        <p className="footer-copy-right">
          ©{new Date().getFullYear()} Falcon SFX. All Rights Reserved |
          Developed by{" "}
          <a
            className=""
            href="https://profcymaglobal.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Profcyma Solutions Pvt Ltd
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
